import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { Button } from "../../action/Button/Button.js";
import { ModalContainer } from "../Modal/components/ModalContainer.js";
import { ModalFooter } from "../Modal/components/ModalFooter.js";
import { ModalHeader } from "../Modal/components/ModalHeader.js";
import { Modal } from "../Modal/Modal.js";
const dialog = "_dialog_hr5ye_3";
const dialogHeader = "_dialogHeader_hr5ye_28";
const dialogBody = "_dialogBody_hr5ye_43";
const dialogFooter = "_dialogFooter_hr5ye_54";
const dialogButton = "_dialogButton_hr5ye_73";
const dialogEntering = "_dialogEntering_hr5ye_77";
const dialogExiting = "_dialogExiting_hr5ye_85";
const styles = {
  dialog,
  dialogHeader,
  dialogBody,
  dialogFooter,
  dialogButton,
  dialogEntering,
  dialogExiting
};
const Dialog = ({
  cancelButton,
  confirmButton,
  children,
  dialogTitle,
  isOpen,
  isAlertDialog,
  isLoading = false,
  isLoadingDescription,
  renderIn,
  restoreFocus = true,
  onCancel,
  onConfirm,
  requiresExplicitChoice,
  closeButtonDescription
}) => {
  return /* @__PURE__ */ jsx(
    Modal,
    {
      restoreFocus,
      isDismissable: !requiresExplicitChoice,
      onClose: onCancel,
      renderIn,
      isOpen,
      children: /* @__PURE__ */ jsxs(
        ModalContainer,
        {
          role: isAlertDialog ? "alertdialog" : "dialog",
          className: styles.dialog,
          component: "div",
          "aria-modal": true,
          "aria-label": dialogTitle,
          transitionStyles: {
            entering: styles.dialogEntering,
            exiting: styles.dialogExiting
          },
          children: [
            /* @__PURE__ */ jsx(
              ModalHeader,
              {
                className: styles.dialogHeader,
                closeButtonDescription,
                children: dialogTitle
              }
            ),
            /* @__PURE__ */ jsx("div", { className: styles.dialogBody, children: typeof children === "string" ? /* @__PURE__ */ jsx(Text, { children }) : /* @__PURE__ */ jsx(Fragment, { children }) }),
            /* @__PURE__ */ jsxs(ModalFooter, { className: styles.dialogFooter, children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.dialogButton,
                  variant: "primary",
                  size: "medium",
                  component: "button",
                  onPress: onConfirm,
                  isLoading,
                  isLoadingDescription,
                  children: confirmButton
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.dialogButton,
                  variant: "outline",
                  size: "medium",
                  component: "button",
                  onPress: onCancel,
                  children: cancelButton
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
export {
  Dialog
};
